var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 0.833008C8.15921 0.833008 6.66683 2.32539 6.66683 4.16634V9.99967C6.66683 11.8406 8.15921 13.333 10.0002 13.333C11.8411 13.333 13.3335 11.8406 13.3335 9.99967V4.16634C13.3335 2.32539 11.8411 0.833008 10.0002 0.833008Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00016 8.33301C5.00016 7.87277 4.62707 7.49967 4.16683 7.49967C3.70659 7.49967 3.3335 7.87277 3.3335 8.33301V9.99967C3.3335 13.3999 5.87904 16.2056 9.16839 16.615C9.16736 16.632 9.16683 16.6491 9.16683 16.6663V17.4997H6.66683C6.20659 17.4997 5.8335 17.8728 5.8335 18.333C5.8335 18.7932 6.20659 19.1663 6.66683 19.1663H13.3335C13.7937 19.1663 14.1668 18.7932 14.1668 18.333C14.1668 17.8728 13.7937 17.4997 13.3335 17.4997H10.8335V16.6663C10.8335 16.6491 10.833 16.632 10.8319 16.615C14.1213 16.2056 16.6668 13.3999 16.6668 9.99967V8.33301C16.6668 7.87277 16.2937 7.49967 15.8335 7.49967C15.3733 7.49967 15.0002 7.87277 15.0002 8.33301V9.99967C15.0002 12.7611 12.7616 14.9997 10.0002 14.9997C7.23874 14.9997 5.00016 12.7611 5.00016 9.99967V8.33301Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.2fd67f14476b203f4f4dc9a3332f5612.svg";
export { ForwardRef as ReactComponent };